import Header from "components/Headers/Header";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Col, Container, Input, Row, Table } from "reactstrap";
import { getAdditionalEarning } from "store/actions/additionalEarningAction";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const AdditionalEarning = () => {
  const currentMonth = new Date().getMonth() + 1;
  const dispatch = useDispatch();
  const [month, setMonth] = useState(currentMonth);
  const [byYear, setByYear] = useState(new Date().getFullYear());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const { additionalEarnings } = useSelector((state) => state.earnings);
  const infoPoints = [
    "Admin monitor monthy those athletes who have earned a Sport Badge with earnings of $400 or more in the current month.",
  ];
  const subPoints = [];
  const infoTitle = "Additional Earnings Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  let newFilterArr = additionalEarnings?.filter((data) => {
    if (data?.amount >= 400) {
      return data;
    }
  });
  useEffect(() => {
    dispatch(getAdditionalEarning(month, byYear));
  }, [month, byYear]);

  const columns = ["Name", "Athlete ID", "Email"];
  const keyMap = {
    Name: "name",
    "Athlete ID": "athleteID",
    Email: "email",
  };

  return (
    <div>
      <Header />
      <Container fluid className="mb-5">
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>

        <Card className="p-3">
          <Row className="no-gutters mt-2">
            <Col md="6" lg="8" sm="4" xs="12"></Col>

            <Col md="3" lg="2" sm="4" xs="12" className="mb-2 mb-sm-0">
              <p className="custom-filter-heading ml-auto mb-2 mb-sm-1 text-left text-sm-right">
                By Month
              </p>
              <div>
                <select
                  className="form-control"
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                >
                  <option value="1">January</option>
                  <option value="2">February</option>
                  <option value="3">March</option>
                  <option value="4">April</option>
                  <option value="5">May</option>
                  <option value="6">June</option>
                  <option value="7">July</option>
                  <option value="8">August</option>
                  <option value="9">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </select>
              </div>
            </Col>
            <Col
              md="3"
              lg="2"
              sm="4"
              xs="12"
              className="pl-0 pl-sm-1 mb-2 mb-sm-0"
            >
              <p className="custom-filter-heading ml-auto mb-2 mb-sm-1 text-left text-sm-right">
                By Year
              </p>
              <Input
                type="select"
                value={byYear}
                onChange={(e) => setByYear(e.target.value)}
              >
                <option value={currentYear}>{currentYear}</option>
                <option value={currentYear - 1}>{currentYear - 1}</option>
                <option value={currentYear - 2}>{currentYear - 2}</option>
                <option value={currentYear - 3}>{currentYear - 3}</option>
                <option value={currentYear - 4}>{currentYear - 4}</option>
                <option value={currentYear - 5}>{currentYear - 5}</option>
              </Input>
            </Col>
          </Row>
          {newFilterArr?.length > 0 ? (
            <TableComponent
              columns={columns}
              data={newFilterArr}
              keyMap={keyMap}
            />
          ) : (
            <h2 className="text-center mt-5">
              No athlete has earned in sport badge more or equal to 400$ on this
              specific month
            </h2>
          )}
        </Card>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
    </div>
  );
};

export default AdditionalEarning;
